var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"russia-list"},[_c('div',{staticClass:"row"},_vm._l((_vm.russiaList),function(item,index){return _c('div',{key:("event-" + index),staticClass:"col-md-3 russia-list__col"},[_vm._t("default",null,{"item":item})],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }